import { AlertModal, Breadcrumb, FlashMessage, Modal, SubModal } from '@policoders/ds';

import Footer from './footer';
import { LoaderFull } from './loader';
import Navbar from './navbar';

interface IProps {
  breadcrumb?: any;
  children?: any;
  navbar?: any;
}

const Layout = ({ children }: IProps) => {
  return (
    <>
      <header>
        <Navbar />
        <Breadcrumb />
      </header>

      <div className="container" style={{ paddingTop: 15, paddingBottom: 40 }}>
        <FlashMessage />
        {children}
      </div>

      <Modal />
      <SubModal />
      <AlertModal />
      <Footer />
      <LoaderFull />
    </>
  );
};

export default Layout;
